<template>
  <div>
    <div class="form-group row mb-4">
      <label class="col-form-label col-lg-2">รหัสแบรนด์ (JDA)</label>
      <label class="col-form-label col-lg-8">{{
        viewComponentModel.jda_id
      }}</label>
    </div>
    <div class="form-group row mb-4" v-if="viewComponentModel.display_name">
      <label class="col-form-label col-lg-2">ชื่อแบรนด์</label>
      <label class="col-form-label col-lg-8"
        ><span class="badge-lang">TH</span
        >{{ viewComponentModel.display_name.th }}</label
      >
    </div>
    <div class="form-group row mb-4" v-if="viewComponentModel.display_name">
      <label class="col-form-label col-lg-2"></label>
      <label class="col-form-label col-lg-8"
        ><span class="badge-lang">EN</span
        >{{ viewComponentModel.display_name.en }}</label
      >
    </div>
    <div class="form-group row mb-4">
      <label class="col-form-label col-lg-2">สินค้า Own Brand</label>
      <div class="col-form-label col-lg-8">
        <label
          v-if="viewComponentModel.is_own_brand === true"
          class="label label-yes"
          >Yes</label
        >
        <label v-else class="label label-no">No</label>
      </div>
    </div>
    <div class="form-group row mb-4">
      <!-- <label class="label label-delete">Delete</label> -->
      <label class="col-form-label col-lg-2">สถานะ</label>
      <!-- <label class="col-form-label col-lg-8">{{
        viewComponentModel.status
      }}</label> -->

      <div class="col-form-label col-lg-8">
        <label
          v-if="viewComponentModel.status === 'Active'"
          class="label label-active"
          >{{ viewComponentModel.status }}</label
        >
        <label
          v-else-if="viewComponentModel.status === 'Delete'"
          class="label label-delete"
          >{{ viewComponentModel.status }}</label
        >
        <label
          v-else-if="viewComponentModel.status === 'Inactive'"
          class="label label-inactive"
          >{{ viewComponentModel.status }}</label
        >
        <label
          v-else-if="viewComponentModel.status === 'Pending'"
          class="label label-pending"
          >{{ viewComponentModel.status }}</label
        >
      </div>
    </div>
    <div class="form-group row mb-4">
      <label class="col-form-label col-lg-2">โลโก้แบรนด์</label>
      <div class="form-group form-inline">
        <div class="col-lg-9">
          <div id="preview">
            <img
              v-if="
                viewComponentModel.images && viewComponentModel.images.length
              "
              :src="viewComponentModel.images[0].url"
              class="rounded"
            />
            <span v-else>-</span>
          </div>
          <button
            v-if="viewComponentModel.images && viewComponentModel.images.length"
            class="btn btn-download-template mt-2"
            style="position: absolute;"
            @click="downloadImage(viewComponentModel.images[0].url)"
          >
            <i
              class="mdi mdi-download"
          
            />Download
          </button>
        </div>
        <!-- <div class="col-lg-1">
                <i  v-if="viewComponentModel.images && viewComponentModel.images.length"  class="mdi mdi-download" @click="downloadImage(viewComponentModel.images[0].url)" />
</div> -->
      </div>
    </div>

    <brand-product-relate
      :brandId="viewComponentModel.id"
    ></brand-product-relate>
  </div>
</template>

<script>
import { StatusEnum } from '@/enum/status.enum.js'
import BrandProductRelate from '@/components/brand/product-relate'
import axios from 'axios'
export default {
  name: 'BrandDetailView',
  components: {
    'brand-product-relate': BrandProductRelate,
  },
  props: {
    value: {
      type: Object,
      default: () => {
        return this.viewComponentModel
      },
    },
  },
  mounted() {},
  data() {
    return {
      viewComponentModel: {
        id: null,
        jda_id: null,
        display_name: {
          th: '',
          en: '',
        },
        status: StatusEnum.ACTIVE,
        is_own_brand: false,
        images: [],
        urlImg: '',
      },
    }
  },
  created: function () {
    if (this.value) this.viewComponentModel = this.value
  },
  watch: {
    value: {
      handler(val) {
        this.viewComponentModel = val
      },
      deep: true,
    },
  },
  methods: {
    async downloadImage(url) {
      var imageurl = `${process.env.VUE_APP_BASE_API}${process.env.VUE_APP_BASE_URL_PRODUCT}api/v1/files?uri=${url}`

      await axios
        .get(imageurl, { responseType: 'blob' })
        .then(async (result) => {
          const imageUrl = URL.createObjectURL(result.data)
          var tag = document.createElement('a')
          tag.href = imageUrl
          tag.download = 'logo.jpg'
          document.body.appendChild(tag)
          tag.click()
          document.body.removeChild(tag)
        })
    },
  },
}
</script>
